import type { FC } from 'react';
import cx from 'classnames';
import { calculateVisibleDots, calculateDotsContainerWidth } from './helpers';
import styles from '../_SimpleCarousel.module.scss';
import type { CarouselDotsProps } from './types';

const CarouselDots: FC<CarouselDotsProps> = ({
  totalItems,
  currentIndex,
  maxVisibleDots = 5,
  onDotClick,
}) => {
  const { dots: visibleDots, offset } = calculateVisibleDots(
    currentIndex,
    totalItems,
    maxVisibleDots
  );

  const containerWidth = calculateDotsContainerWidth(visibleDots.length);

  return (
    <div className={styles.carouselDots}>
      <div
        className={styles.carouselDotsContainer}
        style={{
          transform: `translateX(${offset}px)`,
          width: containerWidth,
        }}
      >
        {Array.from({ length: totalItems }, (_, i) => (
          <button
            key={`dot-${i + 1}`}
            type="button"
            className={cx(styles.carouselDot, {
              [styles.carouselDotActive]: i === currentIndex,
            })}
            onClick={() => onDotClick(i)}
            aria-label={`Go to slide ${i + 1}`}
            aria-current={i === currentIndex ? 'true' : 'false'}
            style={{
              opacity: visibleDots.includes(i) ? 1 : 0,
              pointerEvents: visibleDots.includes(i) ? 'auto' : 'none',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default CarouselDots;
